module.exports = __webpack_public_path__ + "static/media/underconst.a3712ce3.svg";